// extracted by mini-css-extract-plugin
module.exports = {"title":"select-fleet_title__1CHQ4","container":"select-fleet_container__XMVf5","fleet":"select-fleet_fleet__3fI2I","icon":"select-fleet_icon__1MC7r"};